/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/components/InteractiveEducationButton.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import { useEffect, useRef } from 'react';
import { DownIcon } from 'foundations-assets/icons/components/DownIcon';
import { UpIcon } from 'foundations-assets/icons/components/UpIcon';
import AIButton from 'ai-components-ui-library/components/buttons/AIButton';
import { useUserIndustry } from '../hooks/useUserIndustry.migrated';
import UsageTracker from '../../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InteractiveEducationButton = ({
  additionalTracking,
  action,
  display,
  handleClick,
  title,
  use,
  size
}) => {
  const hasTrackedRender = useRef(false);
  const {
    loading: industryLoading
  } = useUserIndustry();
  const shouldWaitForIndustryData = action === 'ai-adapt-to-industry-button-rendered' && industryLoading;
  useEffect(() => {
    if (hasTrackedRender.current || shouldWaitForIndustryData) {
      return;
    }
    hasTrackedRender.current = true;
    UsageTracker.trackStandalone('Learning Center Interaction', Object.assign({}, additionalTracking, {
      action
    }));
  }, [action, additionalTracking, shouldWaitForIndustryData]);
  return /*#__PURE__*/_jsxs(AIButton, {
    onClick: handleClick,
    size: size,
    usageTracker: UsageTracker.tracker,
    use: use,
    children: [title, display ? /*#__PURE__*/_jsx(UpIcon, {
      alignWithText: true
    }) : /*#__PURE__*/_jsx(DownIcon, {
      alignWithText: true
    })]
  });
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/components/InteractiveEducationButton.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export default InteractiveEducationButton;